import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AQTextField',
  props: {
    modelValue: {},
    fieldProps: {},
    label: {},
    placeholder: {},
    type: {},
    counter: {},
    prependInnerIcon: {},
    appendInnerIcon: {},
    required: { type: Boolean },
    readonly: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    // Default fieldProps to an empty object if not provided
    const safeFieldProps = computed(() => props.fieldProps ?? {});

    const emit = __emit;
    const innerValue = computed({
        get: () => props.modelValue,
        set: (val: string | number | undefined) => {
            emit('update:modelValue', val);
        },
    });
    const computedLabel = computed(() => {
        if (props.required) {
            return `${props.label} *`;
        }
        return props.label;
    });

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(_component_v_text_field, _mergeProps({
    modelValue: innerValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event))
  }, safeFieldProps.value, {
    label: computedLabel.value,
    placeholder: props.placeholder,
    variant: "outlined",
    type: props.type,
    counter: props.counter,
    "prepend-inner-icon": props.prependInnerIcon,
    "append-inner-icon": props.appendInnerIcon,
    rounded: "",
    readonly: props.readonly,
    class: "AQ-text-field"
  }), _createSlots({ _: 2 }, [
    (_ctx.$slots.customAppend || _ctx.$slots['append-inner'])
      ? {
          name: "append-inner",
          fn: _withCtx((scope) => [
            _renderSlot(_ctx.$slots, "customAppend"),
            _renderSlot(_ctx.$slots, "append-inner", _normalizeProps(_guardReactiveProps(scope || {})))
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.$slots.customPrependInner || _ctx.$slots['prepend-inner'])
      ? {
          name: "prepend-inner",
          fn: _withCtx((scope) => [
            _renderSlot(_ctx.$slots, "customPrependInner"),
            _renderSlot(_ctx.$slots, "prepend-inner", _normalizeProps(_guardReactiveProps(scope || {})))
          ]),
          key: "1"
        }
      : undefined
  ]), 1040, ["modelValue", "label", "placeholder", "type", "counter", "prepend-inner-icon", "append-inner-icon", "readonly"]))
}
}

})